import React, { useState, useEffect } from 'react';
import {
    countUsersByTestSeriesId,
    countUsersSubmittedByTestSeriesId,
    getAverageScoreByTestSeriesId,
    getMinScoreByTestSeriesId,
    getSubmittedCountByTestSeriesId,
    getNotSubmittedCountByTestSeriesId,
    getPaidTestSeriesUserCount,
    getPurchasedCountByTestSeriesId,
    getRevenueByTestSeriesId,
} from '../../../api/testSeries/testseries';
import { useParams } from 'react-router-dom';

const TestSeriesDashboard = () => {
    const { id } = useParams()
    const [usersAttempted, setUsersAttempted] = useState('');
    const [usersSubmitted, setUsersSubmitted] = useState('');
    const [averageScore, setAverageScore] = useState('');
    const [minScore, setMinScore] = useState('');
    const [submittedCount, setSubmittedCount] = useState('');
    const [notSubmittedCount, setNotSubmittedCount] = useState('');
    const [paidUserCount, setPaidUserCount] = useState('');
    const [purchasedCount, setPurchasedCount] = useState('');
    const [revenue, setRevenue] = useState('');

    useEffect(() => {
        countUsersByTestSeriesId(id).then((res) => {
            if (res.status) {
                setUsersAttempted(res.data);
            }
        });

        countUsersSubmittedByTestSeriesId(id).then((res) => {
            if (res.status) {
                setUsersSubmitted(res.data);
            }
        });

        getAverageScoreByTestSeriesId(id).then((res) => {
            if (res.status) {
                setAverageScore(res.data);
            }
        });

        getMinScoreByTestSeriesId(id).then((res) => {
            if (res.status) {
                setMinScore(res.data);
            }
        });

        getSubmittedCountByTestSeriesId(id).then((res) => {
            if (res.status) {
                setSubmittedCount(res.data);
            }
        });

        getNotSubmittedCountByTestSeriesId(id).then((res) => {
            if (res.status) {
                setNotSubmittedCount(res.data);
            }
        });

        getPaidTestSeriesUserCount().then((res) => {
            if (res.status) {
                setPaidUserCount(res.data);
            }
        });

        getPurchasedCountByTestSeriesId(id).then((res) => {
            if (res.status) {
                setPurchasedCount(res.data);
            }
        });

        getRevenueByTestSeriesId(id).then((res) => {
            if (res.status) {
                setRevenue(res.data);
            }
        });
    }, []);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Users Attempted</h5>
                            <p className="card-text">{usersAttempted}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Users Submitted</h5>
                            <p className="card-text">{usersSubmitted}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Average Score</h5>
                            <p className="card-text">{parseFloat(averageScore).toFixed(2)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Minimum Score</h5>
                            <p className="card-text">{minScore}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Submitted Count</h5>
                            <p className="card-text">{submittedCount}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Not Submitted Count</h5>
                            <p className="card-text">{notSubmittedCount}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Paid User Count</h5>
                            <p className="card-text">{paidUserCount}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Purchased Count</h5>
                            <p className="card-text">{purchasedCount}</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Revenue</h5>
                            <p className="card-text">{revenue}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default TestSeriesDashboard;
